import {
  COMFORT_TEXT,
  EXTERIOR_TEXT,
  FEATURES_TEXT,
  HANDLING_TEXT,
  INTERIOR_TEXT,
  PERFORMANCE_TEXT,
  RELIABILITY_TEXT,
  VALUE_TEXT,
} from '../../../submit-review/_components/page-content/constants';
import type { Rank } from './types';

export const rankMap: Rank[] = [
  { rank: 'Neutral Newbie', points: 0 },
  { rank: 'Clutched', points: 25 },
  { rank: '1st Gear', points: 50 },
  { rank: '2nd Gear', points: 100 },
  { rank: '3rd Gear', points: 250 },
  { rank: '4th Gear', points: 500 },
  { rank: '5th Gear', points: 1000 },
  { rank: '6th Gear', points: 2500 },
  { rank: 'Supercharged', points: 5000 },
  { rank: 'Turbocharged', points: 7500 },
  { rank: 'Nos-ed', points: 15000 },
  { rank: '2Fast2Furious', points: 25000 },
  { rank: 'Ludicrous Mode', points: 50000 },
];

export const ratingCategories = [
  { key: 'comfort', label: COMFORT_TEXT },
  { key: 'reliability', label: RELIABILITY_TEXT },
  { key: 'interior', label: INTERIOR_TEXT },
  { key: 'valueForMoney', label: VALUE_TEXT },
  { key: 'handling', label: HANDLING_TEXT },
  { key: 'features', label: FEATURES_TEXT },
  { key: 'performance', label: PERFORMANCE_TEXT },
  { key: 'exterior', label: EXTERIOR_TEXT },
];
